import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import BeatLoader from 'react-spinners/BeatLoader';
import { ReactSVG } from 'react-svg';

import { Colors } from '../../../../scss/common/style';
import SvgComponent from '../../SvgComponent';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string | JSX.Element | ReactNode;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary | link';
  type?: 'button' | 'reset' | 'submit';
  inline?: boolean;
  transparent?: boolean;
  style?: any;
  className?: string;
  icon?: any;
  reverse?: boolean;
  iconSize?: number;
  rotateIcon?: boolean;
}

export default function BaseButton({
  size,
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  variant = '',
  type = 'button',
  inline = false,
  transparent = false,
  style,
  className,
  icon,
  reverse = false,
  iconSize,
  rotateIcon,
}: Props): JSX.Element {
  const override = {
    display: 'block',
    margin: '0 auto',
  };

  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const color = '#ffffff';
  return (
    <StyledButton
      className={`ak-bg-btn ${inline === true ? 'mb-2' : ''}`}
      disabled={disabled || isSubmitting}
      variant={variant}
      transparent={transparent}
      type={type}
      active={active}
      size={size}
      onClick={onClick}
      title={title}
      style={{ pointerEvents: disabled ? 'none' : style }}
    >
      {isSubmitting ? (
        <div>
          <BeatLoader color={color} loading={true} cssOverride={override} size={3} />
        </div>
      ) : (
        <StyleText reverse={reverse}>
          {icon && (
            <StyledImg
              rotateIcon={rotateIcon}
              src={icon}
              alt={icon}
              isHovered={isHovered}
              isActive={isActive}
              iconSize={iconSize}
            />
          )}
          <ButtonText>{title && title}</ButtonText>
        </StyleText>
      )}
    </StyledButton>
  );
}

const ButtonText = styled.p`
  margin: 0;
  text-align: center;
`;
const StyleText = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.reverse ? 'row-reverse !important' : 'row')};
  text-align: center;
`;

const StyledButton = styled(Button)`
  box-shadow: none !important;

  background-color: ${(props) => (props.active ? Colors.darkBrown : '#FBFBFB')};
  color: ${(props) => (props.active ? '#fff' : '#FBFBFB')};
  &:hover {
    box-shadow: none !important;
    svg path {
      stroke: ${Colors.darkRed};
    }
  }
  &:hover img {
    fill: blue !important;
  }
  &:active {
    box-shadow: none !important;
  }
  font-size: 14px;
  line-height: 15px;
  font-weight: 500;
  border-radius: 200px;
  padding: ${(props) => {
    switch (props.size) {
      case 'sm':
        return '4px 9px';
      case 'lg':
        return '12px 60px';
      default:
        return '9px 47px';
    }
  }};
`;
const StyledImg = styled(ReactSVG)`
  svg {
    font-size: ${(props) => (props.iconSize ? props.iconSize : 20)}px;
    width: ${(props) => (props.iconSize ? props.iconSize : 20)}px;
    height: ${(props) => (props.iconSize ? props.iconSize : 20)}px;
    margin-right: 2px;
  }
  transition: 0.3s ease-in-out;
  transform: ${(props) => (props.rotateIcon ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
